export default "__VITE_ASSET__3syj$fe___"